var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { isCheckboxDisabled, isRowPreselected } from './dataStructureDialogUtils';
import { idRecordDifference, splitArrayById } from '../utils';
export var useTableSelection = function (data) {
    var _a = React.useState(function () {
        return data.length === 1
            ? data // single row -> preselected
            : data.filter(function (row) { return isCheckboxDisabled(row) || isRowPreselected(row); }); // common preselect
    }), right = _a[0], setRight = _a[1];
    var _b = React.useState(function () {
        return idRecordDifference(data, right);
    }), left = _b[0], setLeft = _b[1];
    var _c = React.useState([]), leftChecked = _c[0], setLeftChecked = _c[1];
    var _d = React.useState([]), rightChecked = _d[0], setRightChecked = _d[1];
    var moveRight = function () {
        if (left.length && leftChecked.length) {
            var _a = splitArrayById(left, leftChecked), match = _a.match, rest = _a.rest;
            setLeft(rest);
            setRight(__spreadArray(__spreadArray([], right, true), match, true));
        }
    };
    var moveLeft = function () {
        if (right.length && rightChecked.length) {
            var _a = splitArrayById(right, rightChecked), match = _a.match, rest = _a.rest;
            setRight(rest);
            setLeft(__spreadArray(__spreadArray([], left, true), match, true));
        }
    };
    return { right: right, left: left, leftChecked: leftChecked, setLeftChecked: setLeftChecked, rightChecked: rightChecked, setRightChecked: setRightChecked, moveRight: moveRight, moveLeft: moveLeft };
};
//# sourceMappingURL=useTableSelection.js.map